var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"words-answer mt-0 mt-sm-0 mt-md-0 mt-lg-2 mt-xl-2 ml-0 mb-2 mb-sm-2 mb-md-4 mb-lg-2 mb-xl-2 mr-2 mr-sm-6 mr-md-6 mr-lg-6 mr-xl-6 text-body-2 text-sm-h6 text-md-h5 text-lg-h5 text-xl-h4 unselectable norddruck",attrs:{"elevation":"8","raised":""}},[_vm._v(" "+_vm._s(_vm.word)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }